import { getUserIdentities } from '@api';
import { isPractitioner } from '@domain/validators';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

const IDENTITIES_STALE_TIME = 60 * 60 * 1000; // 1h

export function useUserIdentities(enabled = true) {
  return useQuery({
    queryKey: ['userIdentities'],
    queryFn: getUserIdentities,
    staleTime: IDENTITIES_STALE_TIME,
    enabled,
  });
}

export function useUserIdentity(identityId?: string) {
  const base = useUserIdentities();

  const identity = useMemo(() => {
    if (!base.data || !identityId) {
      return undefined;
    }

    return base.data.list?.find((x) => {
      if (isPractitioner(x) && x.practitionerRoles.length > 0) {
        return x.practitionerRoles.find((practRole) => practRole.id === identityId);
      }

      return x.id === identityId;
    });
  }, [identityId, base.data]);

  return {
    ...base,
    data: identity,
  };
}
